import { gql } from '@apollo/client';

import questionFragment from '../fragments/questionFragment';

export default gql`
  query listQuestions {
    listQuestions {
      ...questionFragment
    }
  }
  ${questionFragment}
`;
